module.exports = __webpack_public_path__ + "static/background-8a2e59f979aebc68c3f82d5fa5a54b83.jpg";